const FromArr = [{
	title: "L1产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择L1产品线",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "年份：",
	inputtype: "year",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择年份",
	width: 150,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "产品分类（L3）：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	multiple: true,
	placeholder: "选择产品分类",
	width: 180,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	collapseTags: true,
}, {
	title: "时间：",
	inputtype: "monthrange",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "选择年份",
	width: 280,
	height: 32,
	disabled: false,
	marginLeft: 30,
	marginTop: 0,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: [],
	modelvalue: []
}]

export {
	FromArr
}